import React from "react";

export type PaperElevationContextType = number;
export const PaperElevationContext =
  React.createContext<PaperElevationContextType>(
    undefined as unknown as PaperElevationContextType
  );
